import { graphql } from 'gql';

export const catalogUERBaseCostHistoryGroupFullNameFilterGql = graphql(`
    query catalogUERBaseCostHistoryGroupFullNameFilter(
        $skip: Int
        $take: Int
        $catalogUniqueId: String!
        $startDate: Date
        $endDate: Date
        $where: FilterValueOfCatalogUerBaseCostGroupFilterDataFilterInput
        $order: [FilterValueOfCatalogUerBaseCostGroupFilterDataSortInput!]
    ) {
        catalogUERBaseCostHistoryGroupFullNameFilter(
            skip: $skip
            take: $take
            catalogUniqueId: $catalogUniqueId
            startDate: $startDate
            endDate: $endDate
            where: $where
            order: $order
        ) {
            items {
                value {
                    groupCode
                    groupName
                }
            }
        }
    }
`);

export const catalogUERBaseCostHistoryCodeFilterGql = graphql(`
    query catalogUERBaseCostHistoryCodeFilter(
        $skip: Int
        $take: Int
        $catalogUniqueId: String!
        $startDate: Date
        $endDate: Date
        $where: FilterValueOfStringFilterInput
        $order: [FilterValueOfStringSortInput!]
    ) {
        catalogUERBaseCostHistoryCodeFilter(
            skip: $skip
            take: $take
            catalogUniqueId: $catalogUniqueId
            startDate: $startDate
            endDate: $endDate
            where: $where
            order: $order
        ) {
            items {
                value
            }
        }
    }
`);

export const catalogUERBaseCostHistoryNameFilterGql = graphql(`
    query catalogUERBaseCostHistoryNameFilter(
        $skip: Int
        $take: Int
        $catalogUniqueId: String!
        $startDate: Date
        $endDate: Date
        $where: FilterValueOfStringFilterInput
        $order: [FilterValueOfStringSortInput!]
    ) {
        catalogUERBaseCostHistoryNameFilter(
            skip: $skip
            take: $take
            catalogUniqueId: $catalogUniqueId
            startDate: $startDate
            endDate: $endDate
            where: $where
            order: $order
        ) {
            items {
                value
            }
        }
    }
`);

export const catalogUERBaseCostHistoryChapterFilterGql = graphql(`
    query catalogUERBaseCostHistoryChapterFilter(
        $skip: Int
        $take: Int
        $catalogUniqueId: String!
        $startDate: Date
        $endDate: Date
        $where: FilterValueOfNullableOfChapterEnumFilterInput
        $order: [FilterValueOfNullableOfChapterEnumSortInput!]
    ) {
        catalogUERBaseCostHistoryChapterFilter(
            skip: $skip
            take: $take
            catalogUniqueId: $catalogUniqueId
            startDate: $startDate
            endDate: $endDate
            where: $where
            order: $order
        ) {
            items {
                value
            }
        }
    }
`);

export const catalogUERBaseCostHistoryUerClassifierFilterGql = graphql(`
    query catalogUERBaseCostHistoryUerClassifierFilter(
        $skip: Int
        $take: Int
        $catalogUniqueId: String!
        $startDate: Date
        $endDate: Date
        $where: FilterValueOfNullableOfUerClassifierEnumFilterInput
        $order: [FilterValueOfNullableOfUerClassifierEnumSortInput!]
    ) {
        catalogUERBaseCostHistoryUerClassifierFilter(
            skip: $skip
            take: $take
            catalogUniqueId: $catalogUniqueId
            startDate: $startDate
            endDate: $endDate
            where: $where
            order: $order
        ) {
            items {
                value
            }
        }
    }
`);

export const catalogUERBaseCostHistoryJustificationFilterGql = graphql(`
    query catalogUERBaseCostHistoryJustificationFilter(
        $skip: Int
        $take: Int
        $catalogUniqueId: String!
        $startDate: Date
        $endDate: Date
        $where: FilterValueOfStringFilterInput
        $order: [FilterValueOfStringSortInput!]
    ) {
        catalogUERBaseCostHistoryJustificationFilter(
            skip: $skip
            take: $take
            catalogUniqueId: $catalogUniqueId
            startDate: $startDate
            endDate: $endDate
            where: $where
            order: $order
        ) {
            items {
                value
            }
        }
    }
`);

export const catalogUERBaseCostHistoryWorkScopeFilterGql = graphql(`
    query catalogUERBaseCostHistoryWorkScopeFilter(
        $skip: Int
        $take: Int
        $catalogUniqueId: String!
        $startDate: Date
        $endDate: Date
        $where: FilterValueOfNullableOfUerBaseCostChangeTypeFilterInput
        $order: [FilterValueOfNullableOfUerBaseCostChangeTypeSortInput!]
    ) {
        catalogUERBaseCostHistoryWorkScopeFilter(
            skip: $skip
            take: $take
            catalogUniqueId: $catalogUniqueId
            startDate: $startDate
            endDate: $endDate
            where: $where
            order: $order
        ) {
            items {
                value
            }
        }
    }
`);
